import { CAST_AI } from '@cast/constants';

import { AgentCodeSnippet } from 'components/code';
import { useGetEdgeLocationOnboardingScriptQuery } from 'hooks/queries/omni';

import { getDocsLink } from '@cast/utils';

import { ExternalLink, Typography, Stack, tokens } from '@cast/design-system';

type EdgeLocationOnboardingProps = {
  clusterId: string;
  edgeLocationId: string;
};

export const EdgeLocationOnboarding = ({
  clusterId,
  edgeLocationId,
}: EdgeLocationOnboardingProps) => {
  const { script, isLoading, error, refetch } =
    useGetEdgeLocationOnboardingScriptQuery({
      clusterId,
      edgeLocationId,
    });

  return (
    <Stack gap={16} height="100%">
      <Typography variant="h5">Configure new edge location</Typography>
      <Typography variant="P14R" color={tokens.theme.fg.structural.secondary}>
        Grant {CAST_AI} the permissions and networking access needed to
        provision nodes in your edge location.{' '}
        <ExternalLink
          link={getDocsLink('docs_omni_getting_started')}
          iconProps={{ size: 16 }}
        >
          Documentation
        </ExternalLink>
      </Typography>

      <Stack gap={12} flexGrow={1}>
        <Typography variant="L12M" color={tokens.theme.fg.structural.secondary}>
          Run the script in your cloud shell or terminal:
        </Typography>
        <Stack
          bgcolor={tokens.theme.bg.structural.surfaceSubtle}
          mx={-32}
          px={32}
          py={20}
        >
          <AgentCodeSnippet
            testId="edge-location-onboarding-script"
            code={script}
            isLoading={isLoading || !script}
            error={error}
            refetch={refetch}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};
